import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { groupBy } from "underscore";
import { Scrollbars } from 'react-custom-scrollbars';
import { Link } from "react-router-dom";

var BookDisplay = require("components/reading/books/BookDisplay");
var BookGrid = require("components/reading/shelves/BookGrid");
var CoinsEarnedDisplay = require("components/reading/shelves/CoinsEarnedDisplay");
var PaginationControls = require("components/utility/PaginationControls");

var AltBoard = require("components/utility/AltBoard");
var StudentTasks = require("components/users/students/StudentTasks");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var QuizDisplay = require("components/writing/quizzes/QuizDisplay");
var AnswerDisplay = require("components/writing/answers/AnswerDisplay");
var ExerciseTile = require("components/writing/activities/ExerciseTile");

var ReadingActions = require("lib/actions/ReadingActions");

var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var CurrentUser = require("lib/account/CurrentUser");
var QuestionTypes = require("lib/academic/QuestionTypes");

require("reading/shelves/expanded_book_details.scss");

@connect(
  (state, props) => {
    var userID = CurrentUser.get().id;
    // My shelf
    return {
      visibleScores: CurrentUser.get().prefs.visible_student_scores,
      quizzes: WritingSelectors.quizzes({ state, conditions: { userID, allowDraft: true } }),
      practiceQuestions: WritingSelectors.nonQuizAnswers({ state, conditions: { userID }, filters: { question_type: QuestionTypes.GENERIC_QUESTION } }),
      essays: WritingSelectors.nonQuizAnswers({ state, conditions: { userID }, filters: { question_type: QuestionTypes.ESSAY_QUESTION } }),
      reviews: WritingSelectors.reviews({ state, conditions: { userID } }),
      responses: WritingSelectors.responses({ state, conditions: { userID } }),
      tasks: WritingSelectors.tasks({ state, conditions: { userID } }),
      questionBuilders: WritingSelectors.metaCognitiveAnswers({ state, conditions: { userID } }),
      books: ReadingSelectors.books({ state, conditions: { userID, allowDraft: true, nonBlank: ["text_id", "title"] } })
    }
  },
  (dispatch, props) => ({
    populateData: (textID = null) => {
      var filters = {
        user_id: CurrentUser.get().id,
        order: "desc-last-active",
        draft: true,
      }
      var embeds = ["book.quiz_user_ids", "book.quiz_draft_user_ids"];

      return dispatch(ReadingActions.fetchBookActivity({
        filters, embeds,
        fetchDetails: true,
        cache: true
      }));
    },
  })
)
@providePopulateData({ waitForLoad: true })
class ExpandedWorkDetails extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    LuckyOrangeClient.tagComponent("ExpandedWorkDetails");
    this.state = {
      currentQuizPage: 1,
      currentReviewPage: 1,
      currentAnswerPage: 1,
      currentEssayPage: 1,
      userID: CurrentUser.get().id
    };
  }

  componentDidMount() {
    this.initScrollbar()
  }
  // dynamically sets height for draft scrollbar
  initScrollbar() {
    if ($(this.refs.draftContentWrap).length) {
      this.setState({ minWindoHeight: window.innerHeight - $(this.refs.draftContentWrap).offset().top - 30 })
    }
  }
  // for separation on draft page
  renderDividerSection(title) {
    return (
      <div className="dividerSection">
        <div className="dividerArea"></div>
        <div className="nameArea">
          <span className="nameString">
            {title}
          </span>
        </div>
      </div>
    );
  }
  // pagination on quiz section
  onQuizPageChange(page) {
    this.setState({ currentQuizPage: page });
  }
  // pagination on review section
  onReviewPageChange(page) {
    this.setState({ currentReviewPage: page });
  }
  // pagination on answer section
  onAnswerPageChange(page) {
    this.setState({ currentAnswerPage: page });
  }
  // pagination on essay section
  onEssayPageChange(page) {
    this.setState({ currentEssayPage: page });
  }

  goToBook(text_id) {
    $wr.redirect("/quiz?text_id=" + text_id);
  }

  handleEmptyLink(e) {
    $wr.nope(e);
    $wr.redirect(`/?bookSearchDropdown=${e.target.className}`);
  }
  //  renders question builders
  renderQuestionBuilderView() {
    // render empty text
    var completedQuestionBuildersFromProps = _.where(this.props.questionBuilders, { draft: false })
    completedQuestionBuildersFromProps = _.sortBy(completedQuestionBuildersFromProps, (questionBuilder) => { return - new Date(questionBuilder.completed_at) })
    if (_.isEmpty(completedQuestionBuildersFromProps)) {
      return (
        <p className="emptySection">
          You have not finished a question builders yet. If you're done with
          a book,<Link to={"/"} className='question-builder' onClick={this.handleEmptyLink}> do a question builders!</Link>
        </p>
      );
    } else {
      if (CurrentUser.get().prefs.allow_student_writing_deletion) {
        var showRemove = true;
      }
      // group answers by book
      var questionBuildersByText = groupBy(completedQuestionBuildersFromProps, 'text_id')
      var textIDArray = _.uniq(_.map(completedQuestionBuildersFromProps, (questionBuilders) => { return questionBuilders.text_id }))
      // placeholders for completed component arrays
      var completedQuestionBuilders = []
      var revisionQuestionBuilders = []
      // loop through books
      // Note: in the past, temp revision answers and completed answers
      // have been kept separate and rendered one after another
      textIDArray.forEach((text_id) => {
        // add 1 book cover per book
        var bookCover = <BookDisplay key={text_id} textID={text_id} coverWidth={75} showCover showAuthor />
        // store all temp revision answers for the book
        var tempRevisionQuestionBuilders = _.map(_.where(questionBuildersByText[text_id], { draft: false, allow_revision: true }), (answer, index) => {
          var bookDisplayPresent = _.size(tempRevisionAnswers) && index == 0
          return (
            <div className="questionBuilderList myWorkAnswers">
              <AnswerDisplay answerID={answer.id} key={answer.id}
                view="question-builder" viewAsStudent
                enabled={{
                  score: this.props.visibleScores,
                  lowerComments: true,
                  date: true,
                  editControls: showRemove,
                  deletion: showRemove,
                  coinsEarned: true,
                  startRevision: true,
                  cancelRevision: true,
                  bookDisplayPresent: bookDisplayPresent
                }} />
            </div>
          );
        });
        // store all answers for the book
        var tempCompletedQuestionBuilders = _.map(_.where(questionBuildersByText[text_id], { draft: false, allow_revision: false }), (answer) => {
          return (
            <div className="questionBuilderList myWorkAnswers" key={answer.completed_at}>
              <AnswerDisplay answerID={answer.id}
                view="question-builder" viewAsStudent
                enabled={{
                  score: this.props.visibleScores,
                  lowerComments: true,
                  date: true,
                  editControls: showRemove,
                  deletion: showRemove,
                  coinsEarned: false
                }} />
            </div>
          );
        });
        // add completed answers to placholder array
        var tempCompletedAnswersList = (
          <div className="bookInformationContainer myWorkContainer" key={text_id}>
            {bookCover}
            {tempCompletedQuestionBuilders}
          </div>
        )
        completedQuestionBuilders = [...completedQuestionBuilders, tempCompletedAnswersList]
        // add temp revision answers to placholder array
        if (tempRevisionQuestionBuilders.length > 0) {
          var tempRevisionAnswersList = (
            <div className="bookInformationContainer myWorkContainer" key={text_id}>
              {bookCover}
              {tempRevisionQuestionBuilders}
            </div>
          )
          revisionQuestionBuilders = [...revisionQuestionBuilders, tempRevisionAnswersList]
        }
      })
      // combine temp revision answers and completed answers
      var allQuestionBuilders = [...revisionQuestionBuilders, ...completedQuestionBuilders]
      // chunck all answers for pagination
      var allQuestionBuilderDisplay = _.chunk(allQuestionBuilders, PER_PAGE)[this.state.currentAnswerPage - 1]
      //	pagination control
      var pagination = (
        <PaginationControls page={this.state.currentAnswerPage}
          perPage={PER_PAGE}
          totalCount={allQuestionBuilders.length}
          onPageChange={this.onAnswerPageChange} />
      );

      return (
        <div className="fullBookInformationContainer">
          {pagination}
          {allQuestionBuilderDisplay}
          {pagination}
        </div>
      );
    }
  }

  renderAnswersView() {
    // render empty text
    var completedAnswers = _.where(this.props.practiceQuestions, { draft: false })
    completedAnswers = _.sortBy(completedAnswers, (answer) => { return - new Date(answer.completed_at) })
    if (_.isEmpty(completedAnswers)) {
      return (
        <p className="emptySection">
          You have not finished a paractice question yet. If you're done with
          a book,<Link to={"/"} className='questions' onClick={this.handleEmptyLink}> answer a practice question!</Link>
        </p>
      );
    } else {
      if (CurrentUser.get().prefs.allow_student_writing_deletion) {
        var showRemove = true;
      }
      // group answers by book
      var answersByText = groupBy(completedAnswers, 'text_id')
      var textIDArray = _.uniq(_.map(completedAnswers, (answer) => { return answer.text_id }))
      // placeholders for completed component arrays
      var completedAnswers = []
      var revisionAnswers = []
      // loop through books
      // Note: in the past, temp revision answers and completed answers
      // have been kept separate and rendered one after another
      textIDArray.forEach((text_id) => {
        // add 1 book cover per book
        var bookCover = <BookDisplay key={text_id} textID={text_id} coverWidth={75} showCover showAuthor />
        // store all temp revision answers for the book
        var tempRevisionAnswers = _.map(_.where(answersByText[text_id], { draft: false, allow_revision: true }), (answer, index) => {
          var bookDisplayPresent = index == 0
          return (
            <div className="answersList myWorkAnswers">
              <AnswerDisplay answerID={answer.id} key={answer.id}
                view="answer" viewAsStudent
                enabled={{
                  score: this.props.visibleScores,
                  lowerComments: true,
                  date: true,
                  editControls: showRemove,
                  deletion: showRemove,
                  coinsEarned: true,
                  startRevision: true,
                  cancelRevision: true,
                  bookDisplayPresent: bookDisplayPresent
                }} />
            </div>
          );
        });
        // store all answers for the book
        var tempCompletedAnswers = _.map(_.where(answersByText[text_id], { draft: false, allow_revision: false }), (answer, index) => {
          var bookDisplayPresent = !_.size(tempRevisionAnswers) && index == 0
          return (
            <div className="answersList myWorkAnswers" key={answer.completed_at}>
              <AnswerDisplay answerID={answer.id}
                view="answer" viewAsStudent
                enabled={{
                  score: this.props.visibleScores,
                  lowerComments: true,
                  date: true,
                  editControls: showRemove,
                  deletion: showRemove,
                  coinsEarned: false,
                  bookDisplayPresent: bookDisplayPresent
                }} />
            </div>
          );
        });
        // add completed answers to placholder array
        var tempCompletedAnswersList = (
          <div className="bookInformationContainer myWorkContainer" key={text_id}>
            {bookCover}
            {tempCompletedAnswers}
          </div>
        )
        completedAnswers = [...completedAnswers, tempCompletedAnswersList]
        // add temp revision answers to placholder array
        if (tempRevisionAnswers.length > 0) {
          var tempRevisionAnswersList = (
            <div className="bookInformationContainer myWorkContainer" key={text_id}>
              {bookCover}
              {tempRevisionAnswers}
            </div>
          )
          revisionAnswers = [...revisionAnswers, tempRevisionAnswersList]
        }
      })
      // combine temp revision answers and completed answers
      var allAnswers = [...revisionAnswers, ...completedAnswers]
      // chunck all answers for pagination
      var allAnswerDisplay = _.chunk(allAnswers, PER_PAGE)[this.state.currentAnswerPage - 1]
      //	pagination control
      var pagination = (
        <PaginationControls page={this.state.currentAnswerPage}
          perPage={PER_PAGE}
          totalCount={allAnswers.length}
          onPageChange={this.onAnswerPageChange} />
      );

      return (
        <div className="fullBookInformationContainer">
          {pagination}
          {allAnswerDisplay}
          {pagination}
        </div>
      );

    }
  }

  renderReviewsView() {
    var completedReviews = _.where(this.props.reviews, { draft: false })
    completedReviews = _.sortBy(completedReviews, (review) => { return - new Date(review.completed_at) })
    if (_.isEmpty(completedReviews)) {
      return (
        <p className="emptySection">
          You have not finished a review yet. If you're done with
          a book,<Link to={"/"} className='reviews' onClick={this.handleEmptyLink}> write a review!</Link>
        </p>
      )
    } else {
      if (CurrentUser.get().prefs.allow_student_writing_deletion) {
        var showRemove = true;
      }
      // pull all non-draft reviews and group by book
      var reviewsByText = groupBy(completedReviews, 'text_id')
      var textIDArray = _.uniq(_.map(completedReviews, (review) => { return review.text_id }))
      var completedReviews = []
      // loop through books
      textIDArray.forEach((text_id) => {
        // add book cover
        var bookCover = <BookDisplay key={text_id} textID={text_id} coverWidth={75} showCover showAuthor />
        // add all reviews under the book cover
        // should only be 1 review per book
        var tempCompletedReviews = _.map(_.where(reviewsByText[text_id], { draft: false }), (review) => {
          return (
            <div className="reveiwsList" key={review.completed_at}>
              <AnswerDisplay answerID={review.id} key={review.id} view="review" viewAsStudent
                enabled={{
                  score: this.props.visibleScores,
                  lowerComments: true,
                  date: true,
                  editControls: showRemove,
                  deletion: showRemove,
                  coinsEarned: true,
                  startRevision: true,
                  cancelRevision: true,
                }} />
            </div>
          );
        })

        var tempCompletedReviewsList = (
          <div className="bookInformationContainer myWorkContainer" key={text_id}>
            {bookCover}
            {tempCompletedReviews}
          </div>
        )
        // add to completed reviews placeholder
        completedReviews = [...completedReviews, tempCompletedReviewsList]
      })
      // chunk for pagination
      completedReviews = _.chunk(completedReviews, PER_PAGE)[this.state.currentReviewPage - 1]

      var pagination = (
        <PaginationControls page={this.state.currentReviewPage}
          perPage={PER_PAGE}
          totalCount={completedReviews.length}
          onPageChange={this.onReviewPageChange} />
      );

      return (
        <div className="reviewsList">
          {pagination}
          {completedReviews}
          {pagination}
        </div>
      )
    }
  }

  renderExercisesView() {
    // filter responses by completed-only
    var responses = _.where(this.props.responses, { draft: false });
    responses = _.sortBy(responses, (response) => { return - new Date(response.completed_at) })
    if (_.isEmpty(responses)) {
      return (
        <p className="emptySection">
          You have not finished an exercise yet.<Link to={"/"} className='exercises' onClick={this.handleEmptyLink}> Start an exercise!</Link>
        </p>
      );
    } else {
      // render exercise titles (used elseware on site)
      var responses = _.sortBy(responses, (response) => {
        return response.demo + "-" + response.completed_at;
      });
      var responseTiles = _.map(responses, (response) => {
        return (
          <ExerciseTile responseID={response.id} key={response.id}
            smallThumbnail allowExpandResponse />
        );
      });

      return (
        <div className="responsesList">
          <AltBoard narrowBoard>
            {responseTiles}
          </AltBoard>
        </div>
      );
    }
  }

  renderQuizzesView() {
    // filter quizzes for completed quizzes only
    var quizzes = _.select(this.props.quizzes, (quiz) => { return quiz.completed_at !== null });
    quizzes = _.sortBy(quizzes, (quiz) => { return - new Date(quiz.completed_at) })
    if (!quizzes || !quizzes.length) {
      return (
        <p className="emptySection">
          You have not finished a quiz yet. If you're done with
          a book,<Link to={"/"} className='quizzes-passed' onClick={this.handleEmptyLink}> do the quiz!</Link>
        </p>
      );
    } else {
      // chunck quizzes for pagination
      var pagedQuizzes = _.chunk(quizzes, PER_PAGE)[this.state.currentQuizPage - 1]
      // loop through all quizzes and display 
      // the same way as the expanded book details page
      var allQuizDisplay = _.map(pagedQuizzes, (quiz) => {
        if (quiz.draft) {
          return (
            <p className="emptySection" key={quiz.id}>
              <BookDisplay textID={quiz.text_id} coverWidth={75}
                showCover showAuthor showReadingLevel={showReadingLevel} />
              <br /><br />
              Your progress on this quiz is saved. If you're ready to do
              more, <a href="#" onClick={this.startQuiz}>finish the quiz</a>!
            </p>
          );
        } else {
          if (this.props.visibleScores && !quiz.excluded) {
            var quizScoreDisplay = (
              <ScoreDisplay subjectID={quiz.id} subjectType="Quiz"
                showDenominator mode={ScoreDisplay.CIRCLE_MODE} />
            );
          }

          if (this.props.view == "quizzes" && this.props.visibleScores) {
            var className = "quizzesTopRight";
          }

          var quizCoinsDisplay = (
            <CoinsEarnedDisplay subjectType="Quiz" subjectID={quiz.id} />
          );

          if (CurrentUser.get().prefs.allow_student_writing_deletion) {
            var showRemove = true;
          }

          var showReadingLevel = CurrentUser.get().prefs.show_students_zpd_icon
            && (this.props.view != ArbitrarySubjects.asCollection(ArbitrarySubjects.CLASS_BOOK));

          return (
            <div className="bookInformationContainer myWorkContainer" key={quiz.id}>
              <BookDisplay textID={quiz.text_id} coverWidth={75}
                showCover showAuthor showReadingLevel={showReadingLevel} />
              <div className="quizContent" >
                <div className={"topRightContainer " + className}>
                  {quizScoreDisplay}
                  {quizCoinsDisplay}
                </div>
                <QuizDisplay quizID={quiz.id} view={AnswerDisplay.QUIZZES_VIEW}
                  viewAsStudent
                  enabled={{
                    lowerComments: true,
                    date: true,
                    editControls: showRemove,
                    deletion: showRemove,
                    startRevision: true,
                    cancelRevision: true,
                  }} />
              </div>
            </div>
          );
        }
      })
      var pagination = (
        <PaginationControls page={this.state.currentQuizPage}
          perPage={PER_PAGE}
          totalCount={quizzes.length}
          onPageChange={this.onQuizPageChange} />
      );

      return (
        <div className='allQuizDisplay'>
          { pagination}
          { allQuizDisplay}
          { pagination}
        </div>
      )
    }
  }

  renderDraftView() {
    var minWindoHeight = 0
    if ($(this.refs.draftContentWrap).length) {
      var minWindoHeight = window.innerHeight - $(this.refs.draftContentWrap).offset().top - 30;
    }
    // filter books by incomplete
    // TODO: find a better way to do this....
    var books = _.filter(this.props.books, function (book) {
      if (book['activity:any:any'] !== undefined && book['activity:any:any'].quiz_draft_counts !== undefined) {
        return book
      }
    });
    // filter all other activities by draft-only
    var reviews = _.where(this.props.reviews, { draft: true });
    var practiceQuestions = _.where(this.props.practiceQuestions, { draft: true });
    var essays = _.where(this.props.essays, { draft: true });
    var responses = _.where(this.props.responses, { draft: true });    
    var questionBuilders = _.where(this.props.questionBuilders, { draft: true });

    // render book grid
    if (books) {
      var quizContent = (
        <BookGrid books={books}
          onBookSelect={this.goToBook}
        />
      )
    }
    // render reviews
    if (reviews.length) {
      var reviewContent = _.map(reviews, (review) => {
        return (
          <div className="bookInformationContainer myWorkContainer" key={review.text_id}>
            <BookDisplay key={review.text_id} textID={review.text_id} coverWidth={75} showCover showAuthor />
            <AnswerDisplay answerID={review.id} key={review.id} asDraft />
          </div>
        );
      })

    }
    if (practiceQuestions.length) {
      // render practice questions
      var answerContent = _.map(practiceQuestions, (answer) => {
        return (
          <div className="bookInformationContainer myWorkContainer" key={answer.text_id}>
            <BookDisplay key={answer.text_id} textID={answer.text_id} coverWidth={75} showCover showAuthor />
            <AnswerDisplay answerID={answer.id} key={answer.id} asDraft />
          </div>
        );
      });
    }
    if (essays.length) {
      // render essays
      var essayContent = _.map(essays, (answer) => {
        return (
          <div className=" myWorkContainer" key={answer.text_id}>
            <AnswerDisplay answerID={answer.id} key={answer.id} asDraft />
          </div>
        );
      });
    }
    // render exercises
    if (responses.length) {
      var responseTiles = _.map(responses, (response) => {
        return (
          <ExerciseTile responseID={response.id} key={response.id}
            smallThumbnail allowExpandResponse />
        );
      });

      var responseContent = (
        <AltBoard narrowBoard>
          { responseTiles}
        </AltBoard>
      );
    }
    // render question Builders
    if (questionBuilders.length) {
      var questionBuilderContent = _.map(questionBuilders, (questionBuilder) => {
        return (
          <div className="bookInformationContainer myWorkContainer" key={questionBuilder.text_id}>
            <BookDisplay key={questionBuilder.text_id} textID={questionBuilder.text_id} coverWidth={75} showCover showAuthor />
            <AnswerDisplay answerID={questionBuilder.id} key={questionBuilder.id} asDraft />
          </div>
        );
      });
    }

    return (
      <div ref="draftContentWrap">
        <Scrollbars autoHeight ref="scrollbars" autoHeightMin={minWindoHeight}>
          <div className="draftContent" >
            {books.length > 0 ? this.renderDividerSection('Quizzes') : ''}
            {books.length > 0 ? quizContent : ''}
            {reviews.length > 0 ? this.renderDividerSection('Reviews') : ''}
            {reviews.length > 0 ? reviewContent : ''}
            {practiceQuestions.length > 0 ? this.renderDividerSection('Answers') : ''}
            {practiceQuestions.length > 0 ? answerContent : ''}
            {essays.length > 0 ? this.renderDividerSection('Essays') : ''}
            {essays.length > 0 ? essayContent : ''}
            {responses.length > 0 ? this.renderDividerSection('Exercises') : ''}
            {responses.length > 0 ? responseContent : ''}
            {questionBuilders.length > 0 ? this.renderDividerSection('Question Builders') : ''}
            {questionBuilders.length > 0 ? questionBuilderContent : ''}
          </div>
        </Scrollbars>
      </div>

    )
  }

  // placeholder for later
  renderTeachersPickView() {

  }

  // render essays
  renderEssayView() {
    // filter essays by completed-only
    var essays = _.where(this.props.essays, { draft: false });
    essays = _.sortBy(essays, (essay) => { return - new Date(essay.completed_at) })
    if (_.isEmpty(essays)) {
      return (
        <p className="emptySection">
          You have not finished an essay yet. If you're done with
          a book,<Link to={"/"} className='essays' onClick={this.handleEmptyLink}> write an essay!</Link>
        </p>
      );
    } else {
      if (CurrentUser.get().prefs.allow_student_writing_deletion) {
        var showRemove = true;
      }

      var pagedEssays = _.chunk(essays, PER_PAGE)[this.state.currentEssayPage - 1]

      // loop through books
      var essayDisplay = pagedEssays.map((essay) => {
        return (
          <div className="essayList" key={essay.completed_at}>
            <AnswerDisplay answerID={essay.id} key={essay.id} view="essay" viewAsStudent
              enabled={{
                score: this.props.visibleScores,
                lowerComments: true,
                date: true,
                editControls: false,
                deletion: showRemove,
                coinsEarned: true,
                startRevision: true,
                cancelRevision: true,
              }} />
          </div>
        );
      })

      var pagination = (
        <PaginationControls page={this.state.currentEssayPage}
          perPage={PER_PAGE}
          totalCount={essays.length}
          onPageChange={this.onEssayPageChange} />
      );

      return (
        <div className='allQuizDisplay'>
          {pagination}
          <div className="bookInformationContainer">
            {essayDisplay}
          </div>
          {pagination}
        </div>
      )
    }
  }

  render() {
    if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.ANSWER)) {
      var fullBookContent = this.renderAnswersView();
    } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.REVIEW)) {
      var fullBookContent = this.renderReviewsView();
    } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.EXERCISE)) {
      var fullBookContent = this.renderExercisesView();
    } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUIZ_ANSWER)) {
      var fullBookContent = this.renderQuizzesView();
    } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.DRAFT)) {
      var fullBookContent = this.renderDraftView();
    } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.QUESTION_BUILDER)) {
      var fullBookContent = this.renderQuestionBuilderView();
    } else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.ESSAY)) {
      var fullBookContent = this.renderEssayView();
    }
    // else if (this.props.view == ArbitrarySubjects.asCollection(ArbitrarySubjects.TEACHERS_PICK_VIEW)) {
    // 	if (this.props.tasks.length > 0) {
    // 		var fullBookContent = this.renderTeachersPickView();
    // 	}
    // }

    return (
      <div className="expandedBookDetails" ref="content">

        <div className="fullBookArea">
          {fullBookContent}
        </div>
      </div>
    );
  }
}

var PER_PAGE = 5;

ExpandedWorkDetails.WrappedComponent.propTypes = StrictPropTypes({
  view: PropTypes.string,
  // Data from @connect
  reviews: PropTypes.array,
  responses: PropTypes.array,
  answers: PropTypes.array,
  quizzes: PropTypes.array,
  activities: PropTypes.array,
  tasks: PropTypes.array,
  books: PropTypes.array,
  questionBuilders: PropTypes.array,
  practiceQuestions: PropTypes.array,
  essays: PropTypes.array,
  visibleScores: PropTypes.bool,
  // Handlers from @connect
  populateData: PropTypes.func,
});

ExpandedWorkDetails.ANSWERS_VIEW = "answers-view";
ExpandedWorkDetails.REVIEWS_VIEW = "reviews-view";
ExpandedWorkDetails.EXERCISES_VIEW = "exercises-view";
ExpandedWorkDetails.QUIZZES_VIEW = "quizzes-view";
ExpandedWorkDetails.TEACHERS_PICK_VIEW = "teachers-pick";

ExpandedWorkDetails.CLASS_REVIEWS_VIEW = "class-reviews-view";

module.exports = ExpandedWorkDetails;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/ExpandedWorkDetails.js